module.exports = __webpack_public_path__ + "img/neirongjiare.0c4cc69e.gif";